<div [kalLoading]="loading">

    @if (model?.NombreMoisAvantFinContrat) {
        <div class="line-date">
            <span>Date de fin de contrat égale ou inférieure à</span> {{model.NombreMoisAvantFinContrat}} mois
        </div>
    }

    @if (allocation.IsNominative) {
        <div class="line-type">
            <span>Type de bénéficiaire :</span>
            <div>
                @for(beneficiaryType of filteredBeneficiaryTypesList; track $index) {
                    <span>
                        - {{ beneficiaryType }}
                    </span>
                }
            </div>
        </div>
    }

    @if (accessibilityRule && accessibilityRule.IsForcageAutorise) {
        <ul class="flexList">
            <li class="verif checked"><span>Forçage autorisé</span></li>
        </ul>
    }

    <div class="line-accessibilite-mode">
        <span>Accessibilité selon : </span>
        <span>
            {{ accessibilityRuleTypeLabel }}
        </span>
    </div>

    @if (accessibilityRule) {
        <div class="line-anciennete">
            <span>{{ accessibilityRuleTypeLabel }} calculée selon :</span>
            @if(referenceDate) {
                <span>
                    {{ (referenceDate?.Libelle || '') + selectedDate }}
                </span>
            }
        </div>
    }

    <kal-radio-group [formControl]="formControl" class="accessibilite-type">

        <kal-radio value="accessibilityBeneficiary">
            Accessibilité pour tous les ouvrants droits
        </kal-radio>

        <kal-radio value="accessibilityCriteria">
            <span>Accessibilité selon critère {{ formControl.value === 'accessibilityCriteria' ? ':' : '' }}</span>
            <span class="gup-U-strongless">{{ selectedAccessibilityCriteria?.Libelle }}</span>
        </kal-radio>

    </kal-radio-group>

    @if (accessibilityRule) {

        @if (formControl.value === 'accessibilityBeneficiary') {

            @if(isAnciennete) {
                <p class="gup-U-margin-bottom--normal">
                    <strong>{{ beneficiaryDate }}</strong>
                </p>
            }

        } @else {
            <kal-table [columns]="columns"
                       [dataSource]="dataSource"
                       [displayedColumns]="displayedColumns">

                <tr *kalHeaderRowDef kal-header-row></tr>

            </kal-table>
        }

        @if (allocation.IsNominative && shouldDisplayBeneficiary) {
            <div>

                <div class="gup-O-separationLine"></div>

                <div class="subtitle">Paramètres</div>

                @if (accessibilityRule.IsConjointHandicape) {
                    <section class="param-list">
                        <div class="param-list__item">
                            <span>Conjoint : </span>
                        </div>

                        <div class="param-list__item">
                            <div>
                                <kal-icon>check</kal-icon>
                                <span>Handicapé</span>
                            </div>
                        </div>
                    </section>
                }

                @if(hasChildren) {
                    <section class="param-list">

                        <div class="param-list__item">
                            <span>Enfants : </span>
                        </div>

                        <div class="param-list__item">

                            @if (accessibilityRule.IsEnfantDirect) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>Direct uniquement</span>
                                </div>
                            }

                            @if (accessibilityRule.IsEnfantHandicape) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>Handicapé</span>
                                </div>
                            }

                            @if (accessibilityRule.IsEnfantACharge) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>A charge</span>
                                </div>
                            }

                            @if (accessibilityRule.AgeEnfantMin && !accessibilityRule.AgeEnfantMax) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>À partir de {{accessibilityRule.AgeEnfantMin}}
                                        an{accessibilityRule.AgeEnfantMin, plural, =1 {} other {s}}</span>
                                </div>
                            }

                            @if (!accessibilityRule.AgeEnfantMin && accessibilityRule.AgeEnfantMax) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>Jusqu'à {{accessibilityRule.AgeEnfantMax}} an{accessibilityRule.AgeEnfantMax, plural, =1 {} other {s}}</span>
                                </div>
                            }

                            @if (accessibilityRule.AgeEnfantMin && accessibilityRule.AgeEnfantMax) {
                                <div>
                                    <kal-icon>check</kal-icon>
                                    <span>De {{accessibilityRule.AgeEnfantMin}} à {{accessibilityRule.AgeEnfantMax}}
                                        an{accessibilityRule.AgeEnfantMax, plural, =1 {} other {s}}</span>
                                </div>
                            }

                            @if (!!accessibilityRule.AgeEnfantMin || !!accessibilityRule.AgeEnfantMax) {
                                <div class="line-age">
                                    <kal-icon>check</kal-icon>
                                    <span class="gup-U-padding-right--small">Age calculé à partir de : </span>
                                    <span>{{ (childrenReferenceDate?.Libelle || '') + childrenSelectedDate }}</span>
                                </div>
                            }

                            <div class="line-accessibilite-children-critere">

                                <kal-icon>check</kal-icon>

                                <span>Accessibilité selon critère : </span>

                                @if (filteredChildrenAccessibilityCriteriaList | arrayNotEmpty) {
                                    <div>
                                        @for(childrenAccessibilityCriteria of filteredChildrenAccessibilityCriteriaList; track $index) {
                                            <span>
                                                - {{ childrenAccessibilityCriteria }}
                                            </span>
                                        }
                                    </div>
                                } @else {
                                    <span>Aucun</span>
                                }

                            </div>

                        </div>

                    </section>
                }
            </div>
        }
    }

</div>
